//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getArticle,addPageView2 } from '@/api/youzheng'
export default {
  name: 'bookdetail',
  props: {},
  data () {
    return {
      title: '',
      id: this.$route.params.code,
      content: '',
      Obj:{
        name: '',
        age: '',
        unit: '',
        pageView: ''
      }
    }
  },
  created () {
    this.addlog()
  },
  mounted () {
    this.getArticleNow()
  },
  methods: {
    addlog(){
      addPageView2({
        id: this.id
      })
    },
    getArticleNow () {
      getArticle({
        id: this.id
      }).then(data => {
        this.title = data.obj.attrname
        document.title = this.title
        this.Obj.name = data.obj.name
        this.Obj.age = data.obj.age
        this.Obj.unit = data.obj.unit
        this.Obj.pageView = data.obj.pageView
        this.content = data.obj.attrcode
      })
    }
  }
}
